import cn from 'classnames'
import React from 'react'
import Link from '../common/util/input/Link'
import config from '../../config.json'

export const CollectionAssetName = ({
    elementRef,
    name,
    linkInactive,
    onClick,
    altOnClick,
    href,
    collection,
}) => {
    const { collectionName, collectionImage, blacklisted, verification } =
        collection

    return (
        <div className={'flex  w-full  y-auto h-[56px] sm:h-[68px]'}>
            <div
                ref={elementRef}
                className="flex items-center justify-start w-full -mt-2 "
            >
                <div className="flex items-center justify-center mr-2 border-2 rounded-lg w-9 sm:w-12 h-9 sm:h-12 border-zinc-300 dark:border-zinc-700">
                    {collectionImage ? (
                        <div
                            className={cn(
                                'w-11 h-11 flex justify-center items-center overflow-hidden rounded-lg m-1/2',
                            )}
                        >
                            <img
                                src={config.ipfspreviewhash
                                    .replaceAll('{collection}', collectionName)
                                    .replaceAll('{hash}', collectionImage)
                                    .replaceAll('{size}', '80')}
                                alt={collectionName}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                <div className="flex flex-col overflow-ellipsis">
                    <div className="w-full mt-2 text-left">
                        <Link
                            inactive={linkInactive}
                            href={href}
                            onClick={onClick}
                            altOnClick={altOnClick}
                            className={cn(
                                'w-full flex justify-start text-zinc-900 dark:text-white',
                                'cursor-pointer font-bold h-1/5  overflow-hidden',
                                {
                                    'text-xs md:text-xs lg:text-xs':
                                        name && name.length >= 25,
                                },
                                {
                                    'text-sm md:text-sm lg:text-sm':
                                        name && name.length < 25,
                                },
                            )}
                        >
                            <div className={cn('w-full')}>
                                <p title={name} className="truncate">
                                    {name && name.length >= 25
                                        ? name.substring(0, 25) + '...'
                                        : name}
                                </p>
                            </div>
                        </Link>
                    </div>
                    <div className="flex flex-row items-center mb-2">
                        <Link
                            href={'/collection/' + collectionName}
                            inactive={blacklisted}
                        >
                            <div className="w-full font-sans">
                                <div className={'flex justify-start'}>
                                    <div
                                        className={cn(
                                            'flex my-auto bottom-2 h-full ',
                                        )}
                                    >
                                        {' '}
                                        <p className="text-xs font-light text-gray-400 md:text-sm">
                                            {' '}
                                            <b>by&nbsp;</b>
                                        </p>
                                        <p
                                            className={cn(
                                                'mb-auto h-full',
                                                {
                                                    'text-xs font-light text-gray-400 md:text-sm':
                                                        collectionName &&
                                                        collectionName.length >
                                                            15,
                                                },
                                                {
                                                    'text-xs font-light text-gray-400 md:text-sm':
                                                        collectionName &&
                                                        collectionName.length <=
                                                            15,
                                                },
                                            )}
                                        >
                                            <b className="truncate">
                                                {collectionName &&
                                                collectionName.length > 20
                                                    ? collection.collection.substring(
                                                          0,
                                                          20,
                                                      ) + '...'
                                                    : collectionName}
                                            </b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <div>
                            {verification && !blacklisted && (
                                <div className={cn('w-5 h-4 ml-1 my-auto')}>
                                    <img
                                        src={'/verified.svg'}
                                        alt="verified"
                                        width={24}
                                        height={24}
                                    />
                                </div>
                            )}
                            {blacklisted && (
                                <div className={cn('w-5 h-4 ml-1 my-auto')}>
                                    <img
                                        src={'/blacklisted.svg'}
                                        alt="blacklisted"
                                        width={150}
                                        height={150}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
